module.exports = __webpack_public_path__ + "img/g2.f399160e.jpg";